type FormFieldErrorProps = {
  message?: string | null
  className?: string
  id?: string
}

const FormFieldError = ({ message, className = 'form-field-error', id }: FormFieldErrorProps) => {
  if (!message) return null
  return (
    <p id={id} className={className} role="alert">
      <i className="fas fa-circle-exclamation" aria-hidden />
      <span>{message}</span>
    </p>
  )
}

export default FormFieldError
